import React, { Component } from "react";
import ReactDOM from "react-dom";
import cn from "classnames";
import Layout from "../Layout";
import "./HtapeLayout.less";
import AbsoluteLayout from "../AbsoluteLayout";
import FillLayout from "../fill/FillLayout";

const CLASS_NAME = "fct-horizontal-tape-layout";

class HorizontalTapeLayout extends Component {
  static defaultProps = {
    scrollable: false
  };

  render() {
    const {
      children,
      className,
      lgap = 0,
      rgap = 0,
      tgap = 0,
      bgap = 0,
      hgap = 0,
      vgap = 0,
      ...props
    } = this.props;
    let left = 0,
      right = 0;
    const leftMap = {},
      rightMap = {};
    const count = React.Children.count(children);
    React.Children.forEach(children, (child, i) => {
      if (child) {
        left >= 0 && (left += lgap + hgap);
        leftMap[i] = left;
        if (left >= 0 && child.props.width >= 0) {
          left += child.props.width;
        } else {
          left = -1;
        }
      }
      if (children[count - i - 1]) {
        right >= 0 && (right += rgap + hgap);
        rightMap[count - i - 1] = right;
        if (right >= 0 && children[count - i - 1].props.width >= 0) {
          right += children[count - i - 1].props.width;
        } else {
          right = -1;
        }
      }
    });
    return (
      <AbsoluteLayout className={cn(CLASS_NAME, className)} {...props}>
        {React.Children.map(children, (child, i) => {
          return (
            child &&
            React.cloneElement(child, {
              top: tgap + vgap,
              bottom: bgap + vgap,
              ...(leftMap[i] >= 0
                ? {
                    left: leftMap[i]
                  }
                : {}),
              ...(rightMap[i] >= 0
                ? {
                    right: rightMap[i]
                  }
                : {})
            })
          );
        })}
      </AbsoluteLayout>
    );
  }
}

HorizontalTapeLayout.Item = FillLayout;
export default HorizontalTapeLayout;



// WEBPACK FOOTER //
// ./layout/tape/HtapeLayout.js